<template>
  <div @click="to()" :class="link ? 'pointer' : ''">
    <div class="card-info align-items-center bg-white">
      <div class="text-center" v-if="icon" style="padding-right: 12px">
        <icon :name="icon" size="24" class="text-primary"/>
      </div>
      <div class="text-muted">
        <h6 class="font-weight-bold text-dark limite mb-0" v-html="title"></h6>
        <slot></slot>
      </div>
      <div class="align-self-center text-primary text-right" style="width: 40px; margin-left: auto" v-if="link || iconPos">
        <i class="fa" :class="iconPos ? iconPos : 'fa-info-circle'"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from "./Icon";
  export default {
    components: {Icon},
    props: ['title', 'link', 'action', 'icon', 'icon-pos'],
    name: "CardInfo",
    methods: {
      to() {
        if (this.link) {
          this.$router.push(this.link)
        } else {
          this.$emit('action')
        }
      }
    }
  }
</script>

<style scoped>
  .card-info {
    padding: 14px;
    color: #343a40;
    border-radius: 16px;
    display: flex;
    border: none;
    box-shadow: var(--shadow);
  }
  .limite {
    max-height: 26px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  @media (min-width: 1200px) {
    .card-info {
      /*min-width: 357px;*/
    }
  }
</style>
